import Alpine from "alpinejs";
import filter, {
    Filters,
} from "DistributionPackages/JvMTECH.Components/Resources/Private/Fusion/Organism/Filter/Filter";

Alpine.data("NewsGrid", (filters: Filters) => ({
    ...filter(filters, true),
    loadMoreButtonVisible: true,
    itemsPerPage: 6,
    currentPage: 1,
    newsParser: new DOMParser(),
    init() {
        Alpine.bind(this.$root, this.root);
        this.initFilter(() => {
            this.currentPage = 0;
            this.loadNextPage();

            if (!this.selection()) {
                this.loadMoreButtonVisible = true;
            }
        });
    },
    root: {
        ["x-on:filterchange"]: function () {
            this.currentPage = 0;
            this.loadNextPage();

            if (!this.selection()) {
                this.loadMoreButtonVisible = true;
            }
        },
    },
    async loadNextPage() {
        this.serverRequest = true;

        this.currentPage++;

        fetch(
            `${window.location.pathname}?page=${this.currentPage}${
                this.objectSelection.category ? "&category=" + this.objectSelection.category : ""
            }${this.objectSelection.company ? "&company=" + this.objectSelection.company : ""}`,
            {
                method: "POST",
            }
        )
            .then((response) => {
                if (response.ok) {
                    response.text().then((text) => {
                        // remove html comments in variable text
                        text = text.replace(/<!--[\s\S]*?-->/g, "");

                        if (!text) {
                            this.loadMoreButtonVisible = false;
                        }

                        const currentItems = [...this.filterContainer().children].map((item) =>
                            item.outerHTML.replaceAll(" ", "")
                        );
                        const requestedItems = this.newsParser.parseFromString(text, "text/html").body.children;

                        if (requestedItems.length < this.itemsPerPage) {
                            this.loadMoreButtonVisible = false;
                        }

                        const newItems = [...requestedItems].filter(
                            ({ outerHTML }) => !currentItems.find((current) => current == outerHTML.replaceAll(" ", ""))
                        );
                        for (const newItem of newItems) {
                            this.filterContainer().insertAdjacentElement("beforeend", newItem);
                        }
                        this.$nextTick(() => {
                            // Sort DOM children by data-date unix timestamp
                            this.filterContainer().replaceChildren(
                                ...[...this.filterContainer().children].sort(
                                    (a, b) => Number(b.dataset.date) - Number(a.dataset.date)
                                )
                            );
                            this.refresh++;
                        });
                    });
                } else {
                    console.log("response error", response.error);
                    this.loadMoreButtonVisible = false;
                }
            })
            .finally(() => {
                this.serverRequest = false;
            });
    },
}));
